import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StackedSidebarService } from '../../services/stacked-sidebar.service';
import { SidebarType } from '../../components/layout/stacked-sidebar/stacked-sidebar.interface';
import { ModalService } from '../../services/modal.service';
import { MarketService } from '../../services/market.service';

@Component({
  selector: 'app-tg-bot-modal',
  templateUrl: './chanel-right-bar.component.html',
  styleUrls: ['./chanel-right-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ChanelRightBarComponent {
  public channel = [];
  public app = [];
  public tgBot = '';

  constructor(
    private readonly stackedSidebarService: StackedSidebarService,
    private dialogRef: MatDialogRef<ChanelRightBarComponent>,
    private readonly modalService: ModalService,
    public readonly marketService: MarketService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.channel = data?.data?.channel;
    this.app = data?.data.app;
    this.tgBot = data?.data.tg;
  }

  onsubmit(key: any) {
    if (key === 'TELEGRAM') {
      this.stackedSidebarService
        .openSidebar(
          {
            type: SidebarType.IntegrationTelegramBot,
            maxWidth: '50vw',
          },
          {
            channel: this.channel,
          },
        )
        .subscribe(() => {});
      this.onClose();
    } else {
      this.stackedSidebarService
        .openSidebar(
          {
            type: SidebarType.IntegrationOlx,
            maxWidth: '50vw',
          },
          {
            channel: this.channel,
            app: this.app,
          },
        )
        .subscribe((res: any) => {
          if (res === 'close') {
            // this.getItemsWithUpdatedParams({}, true);
            // this.loadStatistics();
          }
        });
      this.onClose();
    }
  }

  onClose() {
    this.dialogRef.close();
  }
}
